export const SLIDE_HEIGHT = 600;
export const SLIDES_COLUMNS = 24;
